import { IWizardStepComponent } from '@mwe/models';
import { ADD_PRODUCTS_ROUTE, ADD_PRODUCTS_SEARCH_ROUTE, ServiceStateEnum } from '@mwe/constants';
import { ProductAddStateService } from '@mwe/services';
import { Router } from '@angular/router';
import { Component, inject, OnInit } from '@angular/core';
import { BulletConfirmationViewComponent } from '@mwe/ui/components';
import { AddStaticImagePathPipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-product-add-no-birthdate-in-sap',
  templateUrl: './no-birthdate-in-sap.component.html',
  imports: [BulletConfirmationViewComponent, AddStaticImagePathPipe],
})
export class NoBirthdateInSapComponent implements OnInit, IWizardStepComponent {
  private productAddStateService = inject(ProductAddStateService);
  private router = inject(Router);

  state = ServiceStateEnum.SUCCESS;

  bulletStateMap: Map<string, ServiceStateEnum> = new Map();
  bulletTitleMap: Map<string, string> = new Map();
  bulletLabelMap: Map<string, string> = new Map();
  bulletStateIconMap: Map<string, Map<ServiceStateEnum, string>> = new Map();
  bulletStateClassMap: Map<string, Map<ServiceStateEnum, string>> = new Map();
  bulletIds: string[];

  ngOnInit(): void {
    const bulletType1 = 'noBirthdate_0';
    this.bulletStateMap.set(bulletType1, ServiceStateEnum.SUCCESS);
    this.bulletTitleMap.set(bulletType1, 'products-add.no-birthdate-in-sap.step1.title');
    this.bulletLabelMap.set(bulletType1, 'products-add.no-birthdate-in-sap.step1.text');

    const bulletType2 = 'noBirthdate_1';
    this.bulletStateMap.set(bulletType2, ServiceStateEnum.SUCCESS);
    this.bulletTitleMap.set(bulletType2, 'products-add.no-birthdate-in-sap.step2.title');
    this.bulletLabelMap.set(bulletType2, 'products-add.no-birthdate-in-sap.step2.text');
    const iconMap: Map<ServiceStateEnum, string> = new Map();
    iconMap.set(ServiceStateEnum.SUCCESS, 'fa-envelope');
    this.bulletStateIconMap.set(bulletType2, iconMap);
    const classMap2: Map<ServiceStateEnum, string> = new Map();
    classMap2.set(ServiceStateEnum.SUCCESS, 'bubble has-border-blue has-text-white has-gradient-blue');
    this.bulletStateClassMap.set(bulletType2, classMap2);

    this.bulletIds = Array.from(this.bulletStateMap.keys());
  }

  hasAllNeededData(): boolean {
    // just info in ui
    return true;
  }

  submit(): Promise<void> {
    this.productAddStateService.clearData();
    this.router.navigateByUrl(`/${ADD_PRODUCTS_ROUTE}/${ADD_PRODUCTS_SEARCH_ROUTE}`);
    throw new Error('prevent new wizard step');
  }

  validate(): boolean {
    // just info in ui
    return true;
  }

  cancel(): boolean {
    this.router.navigateByUrl('');
    return true;
  }
}
